import { docLinkPreviewInfoValidPeriod } from './constants';
import { tryQueueGetWacInfo } from '../actions/internalActions';
import getStore from '../store/store';

export default function docLinkHadPreviewInfo(url: string): boolean {
    const docLinkPreviewInfo = getStore.docLinkPreviewInfoMap.get(url);
    const hadPreviewInfo = !!docLinkPreviewInfo;
    if (
        !docLinkPreviewInfo ||
        docLinkPreviewInfo.time + docLinkPreviewInfoValidPeriod <= Date.now()
    ) {
        // did not have preview info or it expired
        // try to push it to getWacInfo queue
        tryQueueGetWacInfo(url);
    }

    return hadPreviewInfo;
}
